import { IProject } from '../../types/global/helper';
import { ITransaction } from '../user/types';

export const types = {
    GET_CASTING_ROLES: 'GET_CASTING_ROLES',
    GET_CASTING_ROLES_SUCCESS: 'GET_CASTING_ROLES_SUCCESS',
    GET_CASTING_ROLES_FAIL: 'GET_CASTING_ROLES_FAIL',
    GET_CURRENT_USER_REVIEWS: 'GET_CURRENT_USER_REVIEWS',
    GET_CURRENT_USER_REVIEWS_SUCCESS: 'GET_CURRENT_USER_REVIEWS_SUCCESS',
    GET_CURRENT_USER_REVIEWS_FAIL: 'GET_CURRENT_USER_REVIEWS_FAIL',
    GET_CURRENT_USER_WATCHLIST: 'GET_CURRENT_USER_WATCHLIST',
    GET_CURRENT_USER_WATCHLIST_SUCCESS: 'GET_CURRENT_USER_WATCHLIST_SUCCESS',
    GET_CURRENT_USER_WATCHLIST_FAILED: 'GET_CURRENT_USER_WATCHLIST_FAILED',
    GET_CURRENT_USER_RECENTLY_VIEWED: 'GET_CURRENT_USER_RECENTLY_VIEWED',
    GET_CURRENT_USER_RECENTLY_VIEWED_SUCCESS: 'GET_CURRENT_USER_RECENTLY_VIEWED_SUCCESS',
    GET_CURRENT_USER_RECENTLY_VIEWED_FAIL: 'GET_CURRENT_USER_RECENTLY_VIEWED_FAIL',
    GET_CURRENT_USER_AUDITIONS: 'GET_MY_AUDITIONS',
    GET_CURRENT_USER_AUDITIONS_SUCCESS: 'GET_MY_AUDITIONS_SUCCESS',
    GET_CURRENT_USER_AUDITIONS_FAIL: 'GET_MY_AUDITIONS_FAIL',
    GET_CONTRIBUTIONS: 'GET_CONTRIBUTIONS',
    GET_CONTRIBUTIONS_SUCCESS: 'GET_CONTRIBUTIONS_SUCCESS',
    GET_CONTRIBUTIONS_FAIL: 'GET_CONTRIBUTIONS_FAIL',

    GET_ACCOUNT_DETAILS: 'GET_ACCOUNT_DETAILS',
    GET_ACCOUNT_DETAILS_SUCCESS: 'GET_ACCOUNT_DETAILS_SUCCESS',
    GET_ACCOUNT_DETAILS_FAIL: 'GET_ACCOUNT_DETAILS_FAIL',

    ACCOUNT_REFRESH: 'ACCOUNT_REFRESH',
    ACCOUNT_REFRESH_SUCCESS: 'ACCOUNT_REFRESH_SUCCESS',
    ACCOUNT_REFRESH_FAIL: 'ACCOUNT_REFRESH_FAIL',

    GET_USER_AUDME_PROFILES: 'GET_USER_AUDME_PROFILES',
    GET_USER_AUDME_PROFILES_SUCCESS: 'GET_USER_AUDME_PROFILES_SUCCESS',
    GET_USER_AUDME_PROFILES_FAIL: 'GET_USER_AUDME_PROFILES_FAIL',

    GET_USER_DASHBOARD: 'GET_USER_DASHBOARD',
    GET_USER_DASHBOARD_SUCCESS: 'GET_USER_DASHBOARD_SUCCESS',
    GET_USER_DASHBOARD_FAIL: 'GET_USER_DASHBOARD_FAIL',

    GET_USER_LIKES: 'GET_USER_LIKES',
    GET_USER_LIKES_SUCCESS: 'GET_USER_LIKES_SUCCESS',
    GET_USER_LIKES_FAIL: 'GET_USER_LIKES_FAIL',

    GET_SINGLE_LIKE: 'GET_SINGLE_LIKE',
    GET_SINGLE_LIKE_SUCCESS: 'GET_SINGLE_LIKE_SUCCESS',
    GET_SINGLE_LIKE_FAIL: 'GET_SINGLE_LIKE_FAIL',
    RESET_AUDME_PROFILE: 'RESET_AUDME_PROFILE',

    REFRESH_USER_DASHBOARD: 'REFRESH_USER_DASHBOARD',

    // External Bank Account Types
    GET_EXTERNAL_ACCOUNT_INFO: 'GET_EXTERNAL_ACCOUNT_INFO',
    GET_EXTERNAL_ACCOUNT_INFO_SUCCESS: 'GET_EXTERNAL_ACCOUNT_INFO_SUCCESS',
    GET_EXTERNAL_ACCOUNT_INFO_FAIL: 'GET_EXTERNAL_ACCOUNT_INFO_FAIL',

    GET_USER_EXTERNAL_ACCOUNTS: 'GET_USER_EXTERNAL_ACCOUNTS',
    GET_USER_EXTERNAL_ACCOUNTS_SUCCESS: 'GET_USER_EXTERNAL_ACCOUNTS_SUCCESS',
    GET_USER_EXTERNAL_ACCOUNTS_FAIL: 'GET_USER_EXTERNAL_ACCOUNTS_FAIL',

    CREATE_EXTERNAL_ACCOUNT: 'CREATE_EXTERNAL_ACCOUNT',
    CREATE_EXTERNAL_ACCOUNT_SUCCESS: 'CREATE_EXTERNAL_ACCOUNT_SUCCESS',
    CREATE_EXTERNAL_ACCOUNT_FAIL: 'CREATE_EXTERNAL_ACCOUNT_FAIL',

    UPDATE_EXTERNAL_ACCOUNT: 'UPDATE_EXTERNAL_ACCOUNT',
    UPDATE_EXTERNAL_ACCOUNT_SUCCESS: 'UPDATE_EXTERNAL_ACCOUNT_SUCCESS',
    UPDATE_EXTERNAL_ACCOUNT_FAIL: 'UPDATE_EXTERNAL_ACCOUNT_FAIL',

    DELETE_EXTERNAL_ACCOUNT: 'DELETE_EXTERNAL_ACCOUNT',
    DELETE_EXTERNAL_ACCOUNT_SUCCESS: 'DELETE_EXTERNAL_ACCOUNT_SUCCESS',
    DELETE_EXTERNAL_ACCOUNT_FAIL: 'DELETE_EXTERNAL_ACCOUNT_FAIL',

    /** This should only be used by actual user or admins only */
    GET_ACCOUNT_BALANCE: 'GET_ACCOUNT_BALANCE',
    GET_ACCOUNT_BALANCE_SUCCESS: 'GET_ACCOUNT_BALANCE_SUCCESS',
    GET_ACCOUNT_BALANCE_FAIL: 'GET_ACCOUNT_BALANCE_FAIL',
};

export type LikeCategory = 'movie' | 'review' | 'act' | 'project' | 'contest' | 'comment' | 'thougth';

export interface ILike {
    created_at: string;
    like_type: string;
    _id: string;
    user: string;
    created_by: string;
    project: IProject;
    like_category: LikeCategory;
    comment?: string;
    /** The below allows us to make real time interaction */
    optimistic?: boolean;
}

export interface IGetUserLikes {
    /** Pass the below as `&project=projectId` to work */
    param: string;
}

export type TLikeOrigin = 'home' | 'details' | 'profile' | 'watch';

export interface ILikeResponse {
    data: ILike;
    like_origin?: TLikeOrigin;
    documentId?: string;
}

// External Bank Account Interfaces
export interface IBankInfo {
    id: string;
    name: string;
    code: string;
}

export interface IExternalAccountInfoResponse {
    NG: IBankInfo[];
    GH: IBankInfo[];
    KY: IBankInfo[];
    KE?: IBankInfo[];
}

export interface IExternalAccount {
    _id: string;
    id?: string;
    name: string;
    external_account_type:
        | 'bank_account'
        | 'ach'
        | 'paypal'
        | 'mobile_money'
        | 'mobile_money_business'
        | 'swift'
        | 'nuban';
    country: string;
    account_currency: string;
    bank_details?: {
        routing_number?: string | number;
        account_number: number | string;
        address?: string;
        bank_name?: string;
        bank_code?: string;
        swift_code?: string;
        account_holder_name?: string;
        account_type?: string;
        document_type?: string;
        document_number?: string;
    };
    paypal_details?: {
        email: string;
        username: string;
    };
    mobile_money_details?: {
        phone_number: string;
        name: string;
        address?: string;
        mobile_money_code: string;
        mobile_money_name: string;
    };
    account_identifier?: string;
    is_primary?: boolean;
    payout_processor?: 'paystack' | 'stripe' | null;
    payout_rail?: string;
    verification_status?:
        | 'verified'
        | 'pending'
        | 'failed'
        | 'pending_processor'
        | 'pending_manual_review'
        | 'not_applicable';
    verified_account_name?: string | null;
    processor_recipient_id?: string | null;
    stripe_region?: 'us' | 'eu' | null;
    verification_error?: string | null;
    created_at?: string;
    updated_at?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface ICreateExternalAccountRequest {
    name: string;
    external_account_type:
        | 'bank_account'
        | 'ach'
        | 'paypal'
        | 'mobile_money'
        | 'mobile_money_business'
        | 'swift'
        | 'nuban';
    country: string;
    account_currency: string;
    is_primary?: boolean;
    bank_details?: {
        routing_number?: string | number;
        account_number: number | string;
        address?: string;
        bank_name?: string;
        bank_code?: string;
        swift_code?: string;
        account_holder_name?: string;
        account_type?: string;
        document_type?: string;
        document_number?: string;
    };
    paypal_details?: {
        email: string;
        username: string;
    };
    mobile_money_details?: {
        phone_number: string;
        name: string;
        address?: string;
        mobile_money_code: string;
        mobile_money_name: string;
    };
}

export interface IUpdateExternalAccountRequest {
    id: string;
    payload: Partial<ICreateExternalAccountRequest>;
}

export interface IExternalAccountResponse {
    data: IExternalAccount[];
    message: string;
    status: string;
}

export interface IGetAccount {
    userId: string;
}

export interface IThspianAccount {
    _id: string;
    account_number: string;
    account_name: string;
    balance: number;
    currency: string;
    account_status: string;
    created_by: string;
    external_accounts: any[];
    createdAt: string;
    updatedAt: string;
    transactions?: ITransaction[];
    __v: number;
}
